export default "__VITE_ASSET__Cm9p4NXt__"